module.exports = __webpack_public_path__ + "static/media/pypng.8754901c.png";